import Vue from 'vue';
import Vuex from 'vuex';

import { ui } from "./modules/ui.module"
import { auth } from "./modules/auth.module"
import { data } from "./modules/data.module"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        loading: false,
        overlay: false,
    },
    getters: {
        loading(state) {
            return state.loading;
        },
        overlay(state) {
            return state.overlay;
        },
    },
    mutations: {
        set_loading(state, loading) {
            state.loading = loading;
        },
        set_overlay(state, overlay) {
            state.overlay = overlay;
        },
    },
    modules: {
        data,
        ui,
        auth
    }
});
